import {IController} from "angular";
import {UserSettings} from "modules/user_settings/model/UserSettings";
import {initialiseEmailToneOption} from "modules/user_settings/model/InitialisedEmailRowOptions";
import {
    EmailLength,
    EnthusiasticToneConfig,
    PersonalisationConfig,
    PersuasiveToneConfig,
    ProfessionalismToneConfig,
    UrgencyToneConfig
} from "modules/user_settings/model/enums/enums";
import {ToastNotificationService} from "modules/utils/ToastNotificationService";
import {UserSettingsService, UserSettingsServiceName} from "modules/user_settings/service/UserSettingsService";
import {ToastNotificationServiceName} from "modules/utils/names/serviceNames";

import "../../../styles/left-side.scss"
import {EmailPreviewService, EmailPreviewServiceName} from "modules/user_settings/service/EmailPreviewService";
import {ToneOption} from "modules/user_settings/component/email-settings/email-tone-row/email-tone-row";

export interface ToneOptionBlock {
    groupName: string;
    toneOptions: Array<ToneOption>
    selectedValue: string;
}

export interface LengthOption {
    label: string;
    value: string;
}

export class LeftSide implements IController {

    public emailToneOptions: Array<ToneOptionBlock>;
    public emailLengthOptions: Array<LengthOption>;
    public selectedEmailLength: string;
    public updatedSettings: UserSettings;
    public isSaveEnabled: boolean = false;
    public includeEmoji: boolean;
    public settings: UserSettings;
    public onSaveSettings: any;

    public static instance = {
        template: require('./left-side.html'),
        controller:[
            UserSettingsServiceName,
            EmailPreviewServiceName,
            ToastNotificationServiceName,
            LeftSide
        ],
        bindings: {
            updatedSettings: '=',
            settings: '<',
            onSaveSettings: '&'
        },
    };

    constructor(
        private userSettingsService: UserSettingsService,
        private emailPreviewService: EmailPreviewService,
        private notificationService: ToastNotificationService
    ) {}

    $onInit() {
        this.updatedSettings = this.userSettingsService.cloneSettings(this.settings);
        this.includeEmoji = this.settings.includeEmoji;
        this.initializeEmailLengthOptions();
        this.initializeToneOptions();
    }


    initializeToneOptions() {
        this.emailToneOptions = initialiseEmailToneOption(this.settings);
    }

    initializeEmailLengthOptions() {
        this.emailLengthOptions = [
            {label: "Single Paragraph", value: "SINGLE_PARAGRAPH"},
            {label: "Multi-Paragraph", value: "MULTI_PARAGRAPH"},
            {label: "Micro-Email", value: "MICRO_EMAIL"},
        ];
        this.selectedEmailLength = this.settings.emailLength;
    }

    saveSettingsAndDeleteOutdatedPreview() {
        this.userSettingsService
            .saveSettings(this.updatedSettings)
            .then((response) => {
                    this.isSaveEnabled = false;
                    this.settings = this.userSettingsService.cloneSettings(this.updatedSettings)
                    this.notificationService.generateSuccessMessage("Settings was updated successfully");
                }
            ).catch((error) => {
            console.error("Error updating settings", error);
        })
        this.emailPreviewService.deletePreview();
    }

    saveIncludingEmoji() {
        this.updatedSettings.includeEmoji = !this.updatedSettings.includeEmoji
        console.log(this.updatedSettings.includeEmoji)
        this.isSaveEnabled = this.userSettingsService.settingsChanged(this.updatedSettings, this.settings)
    }

    updateToneSetting(toneOption: ToneOptionBlock) {
        console.log("Started changin")
        this.emailToneOptions
            .find(t => t.groupName == toneOption.groupName)
            .selectedValue = toneOption.selectedValue;
        switch (toneOption.groupName) {
            case "professionalismToneConfig":
                this.updatedSettings.professionalismToneConfig = toneOption.selectedValue as ProfessionalismToneConfig;
                break;
            case "enthusiasticToneConfig":
                this.updatedSettings.enthusiasticToneConfig = toneOption.selectedValue as EnthusiasticToneConfig;
                break;
            case "persuasiveToneConfig":
                this.updatedSettings.persuasiveToneConfig = toneOption.selectedValue as PersuasiveToneConfig;
                break;
            case "urgencyToneConfig":
                this.updatedSettings.urgencyToneConfig = toneOption.selectedValue as UrgencyToneConfig;
                break;
            case "personalisationConfig":
                this.updatedSettings.personalisationConfig = toneOption.selectedValue as PersonalisationConfig;
                break;
        }
        console.log(this.updatedSettings)
        this.isSaveEnabled = this.userSettingsService.settingsChanged(this.updatedSettings, this.settings)
    }

    public updateEmailCallback = (selectedValue: string) => {
        this.updatedSettings.emailLength = selectedValue as EmailLength;
        this.isSaveEnabled = this.userSettingsService.settingsChanged(this.updatedSettings, this.settings)
    }

}
